const catalogRestrictions = {
  title: "Product restrictions",
  description:
    "Manage the products and brands available for provider recommendations for this practice.",
  restrictedGroups: "Restricted groups",
  restrictedGroupsProvidersOnly: "Providers only",
  restrictedGroupsAllUsers: "Providers and patients",
  restrictedGroupsTooltip:
    "Choose which user groups are affected by product restrictions in this practice.",
  catalogAccess: "Catalog access",
  catalogAccessOpen: "Open",
  catalogAccessClosed: "Closed",
  catalogAccessTooltip:
    "When closed, only unrestricted products are visible. When open, restricted products are visible but cannot be purchased.",
  findBrandsOrProducts: "Find brands or products",
  searchPlaceholder: "Search by brand or product name",
  noResultsFound: "No results found",
  typeToSearch: "Type to search for brands or products",
  suggestedSearches: "Suggested searches",
  inBrands: "in Brands",
  inProducts: "in Products",
  restricted: "Restricted",
  searchAllProducts: "Search all products for",
  searchLabel: "Search:",
  findProduct: "Find a product",
  brandLabel: "Brand:",
  unrestrictBrand: "Unrestrict brand",
  restrictions: "Restrictions",
  productsCount: "{{count}} product",
  productsCount_plural: "{{count}} products",
  exception: "exception",
  exception_plural: "exceptions",
  exceptionLabel: "Exception",
  product: "product",
  product_plural: "products",
  discardChanges: "Discard changes",
  reviewChanges: "Review changes",
  noRestrictionsYet: "No restrictions added yet",
  unsavedChanges: "You have unsaved changes",
  restrictionsSavedSuccess: "Restrictions saved successfully",
  restrictedGroupsUpdated: "Restricted groups updated successfully",
  changesDiscardedSuccess: "Changes discarded",
  serverStateChanged:
    "Restrictions were updated by another user. Your pending changes have been recalculated.",
  noChangesLeftToSave: "No changes left to save.",
  reviewChangesModal: {
    title: "Review changes",
    newlyRestrictedProducts: "Newly restricted products",
    newlyAvailableProducts: "Newly available products",
    cancel: "Cancel",
    saveChanges: "Save changes",
    explanatoryText: {
      line1: "Providers can't recommend these in new plans and templates.",
      line2: "Patients who have these products in existing plans retain access and auto refills.",
      line3:
        "Patients who do not have these products in existing plans, including those who have been self-serve ordering, lose the ability to purchase and auto refill immediately.",
    },
    exceptionLabel: "Exception:",
  },

  restrictedGroupsModalTitle: "Restricted groups",
  restrictedGroupsModalWarning:
    "This will immediately apply all saved restrictions to the chosen group(s) when saved.",
  restrictedGroupsProvidersOnlyDescription:
    "Providers can't recommend restricted products in new plans or templates. Patients can still access and purchase these products from your storefront.",
  restrictedGroupsProvidersOnlyNote:
    "For practices that want to curate what providers recommend but allow patients the ability to self-serve from the entire catalog.",
  restrictedGroupsAllUsersDescription:
    "Providers can't recommend restricted products in new plans or templates. Patients can't access and purchase these products from your storefront, unless previously recommended to them in a plan.",
  catalogAccessModalTitle: "Edit catalog access",
  catalogAccessModalWarning: "This will immediately apply to patients when saved.",
  catalogAccessOpenDescription:
    "Patients (excluding minors) can browse the catalog and buy any unrestricted product. Apex Energetics and Ortho Molecular Products must be recommended to be purchased.",
  catalogAccessClosedDescription: "Patients only see recommended products and public favorites.",
  mostCommon: "Most common",
  cancel: "Cancel",
  save: "Save",
  activePlansWarningModalTitle: "Restricting high-value product",
  activePlansWarningModalMessage:
    "This product is currently in {{count}} active treatment plans. Restricting it will prevent providers from adding it to new plans, but patients with existing prescriptions will retain access to reorder.",
  restrictProduct: "Restrict product",
  confirmRestrictBrandModalTitle: "Restrict brand: {{brandName}}",
  confirmRestrictBrandModalMessage:
    "All current and future {{brandName}} products will be hidden from the catalog and won't be able to be used in new treatment plans. Specific products can be unrestricted.",
  restrictBrand: "Restrict brand",
  confirmRestrictAllProductsModalTitle: "Restrict brand: {{brandName}}",
  confirmRestrictAllProductsModalMessage: {
    line1: "You've restricted all {{brandName}} products. Do you want to restrict this brand?",
    line2:
      "If restricting the brand, all current and future {{brandName}} products will be hidden from the catalog and won't be able to be used in new treatment plans. Specific products can be unrestricted.",
  },

  noClose: "No, only restrict products",
  yesRestrictBrand: "Yes, restrict brand",

  tooltipRestrictProduct: "Restrict {{name}}",
  tooltipUnrestrictProduct: "Unrestrict {{name}}",
  tooltipUndoPendingRestriction: "Undo pending restriction for {{name}}",
  tooltipUndoPendingUnrestriction: "Undo pending unrestriction for {{name}}",
  tooltipRestoreBrand: "Restore {{name}}",
  tooltipRemoveBrand: "Remove {{name}}",
  editRestrictedGroups: "Edit restricted groups",
};

export { catalogRestrictions };
